import { FleekError } from './FleekError';

type InvalidAdminAccessTokenErrorOptions = {
  adminAccessToken: string;
};

export class InvalidAdminAccessTokenError extends FleekError<InvalidAdminAccessTokenErrorOptions> {
  public name = 'InvalidAdminAccessTokenError';

  toString = () => 'Admin access token is invalid.';
}
